module.exports = __webpack_public_path__ + "img/mguanyuguolian.58a23ded.png";